import React from "react";
import { Link } from "react-router-dom";

import "../AccountReturn/AccountReturn.css";

export default function TopUpReturnToAccount() {
  return (
    <div className="account-return-page">
      <div className="account-return-overlay" />
      <div className="container account-return-container">
        <div className="account-return-card text-center">
          <div className="account-return-icon-wrapper" aria-hidden="true">
            <span className="account-return-icon">✓</span>
          </div>

          <p className="account-return-badge">Top-Up Complete</p>

          <h1 className="account-return-title">Thank you!</h1>

          <p className="account-return-description">
            Your wallet has been credited successfully.
          </p>

          <div className="account-return-actions">
            <Link
              to="/money-credit-dashboard"
              className="account-return-primary-btn"
            >
              Back to Wallet
            </Link>
            <Link to="/dashboard" className="account-return-secondary-btn">
              Back to Dashboard
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
